module.exports = __webpack_public_path__ + "img/ic-settings.9a86f375.svg";